import { render, staticRenderFns } from "./Calc.vue?vue&type=template&id=cfd3939a&scoped=true"
import script from "./Calc.vue?vue&type=script&lang=ts"
export * from "./Calc.vue?vue&type=script&lang=ts"
import style0 from "./Calc.vue?vue&type=style&index=0&id=cfd3939a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd3939a",
  null
  
)

export default component.exports